import React from 'react';
import './Breadcrumbs.css';

const Breadcrumbs = ({ items = [] }) => {
  if (!items.length) return null;
  const navigate = (path) => {
    if (!path) return;
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((item, i) => (
          <li key={i}>
            {i < items.length - 1 ? (
              <>
                <button type="button" className="breadcrumb-link" onClick={() => navigate(item.url)}>
                  {item.name}
                </button>
                <span className="breadcrumb-sep">›</span>
              </>
            ) : (
              <span className="breadcrumb-current">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
